var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C13.1046 0 14 0.895431 14 2V4H11.5996V2.40039H2.40039V15.5996H11.5996V14H14V16C14 17.0357 13.2128 17.887 12.2041 17.9893L12 18H2L1.7959 17.9893C0.854346 17.8938 0.1062 17.1457 0.0107422 16.2041L0 16V2C0 0.895431 0.895431 4.83192e-08 2 0H12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.32144C16 6.92573 16.5129 6.77056 16.7324 7.09976L18 9.00015L16.7324 10.9015C16.5127 11.2302 16 11.0744 16 10.6789V10.0002H7C6.44781 10.0002 6.00015 9.55231 6 9.00015C6 8.44787 6.44772 8.00015 7 8.00015H16V7.32144Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu8);
export default __webpack_public_path__ + "static/media/menu8.662c9bf706fe4c8ae87e596a46da444e.svg";
export { ForwardRef as ReactComponent };